import { dataHooks as wixDataHooks } from '@wix/data-hooks'

export const dataHooks = wixDataHooks<{
  nextButton: {}
  template: {}
  appItem: { key: string }
}>('headless-apps')
